export enum CapacitorPluginsName {
  Keyboard = 'Keyboard',
  StatusBar = 'StatusBar',
  BarcodeScannerPlugin = 'BarcodeScannerPlugin',
  BarcodeScannerCapacitorPlugin = 'BarcodeScanner',
}
